// routes
import { PATH_NetRetail } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    netRetail: icon('ic_dataupload')
};

const navConfig = [
    {
        items: [            
            {
                title: 'Net Retailing', path: PATH_NetRetail.netRetail.root, icon: ICONS.netRetail,
                children: [
                    { title: 'DSR,PDC/PRI Dump', path: PATH_NetRetail.netRetail.dsr_pdc_priDump }]
            }

        ]
    }
];
export default navConfig;